export default interface Username {
  uid: string;
}
